import * as angular from 'angular';

import './voziq.scss';

import { VoziqOfferFlow } from './voziqOfferFlow.service';
import { voziqOffersModal } from './voziqOffersModal.component';
import { voziqSignModal } from './voziqSignModal.component';
import { voziqAcceptedModal } from './voziqAcceptedModal.component';
import { voziqOffersBanner } from './voziqOffersBanner.component';
import { voziqOfferSummary } from './voziqOfferSummary.component';

export default angular.module('fp:customerportal:common:voziq', [])
    .service('voziqOfferFlow', VoziqOfferFlow)
    .component('fpVoziqOffersModal', voziqOffersModal)
    .component('fpVoziqSignModal', voziqSignModal)
    .component('fpVoziqAcceptedModal', voziqAcceptedModal)
    .component('fpVoziqOffersBanner', voziqOffersBanner)
    .component('fpVoziqOfferSummary', voziqOfferSummary);
